import { KYMW1312Model } from '../kymw1312.model';
import { KYMW1312GetSetPlanPromotionNoModel } from '../vo/kymw1312-get-set-plan-promotion-no.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * バンドルミックスマッチ画面　プロモーションNoを取得するサービス
 *
 * @export GetSetPromotionNoService
 * @class GetSetPromotionNoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSetPromotionNoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1312Model}
   * @memberof GetSetPromotionNoService
   */
  private model: KYMW1312Model;

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {KYMW1312GetSetPlanPromotionNoModel}
   * @memberof GetSetPromotionNoService
   */
  private vo: KYMW1312GetSetPlanPromotionNoModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSetPromotionNoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSetPromotionNoService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1312Model>model;
    this.vo = vo;
    this.send('getSetPlanPromotionNo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSetPromotionNoService
   */
  success(data: any): void {
    this.model.updatePromotionNo(data);

    // 画面項目初期化
    this.model.KYMW1312Component.initDisplay();

    // ボタン活性制御
    this.model.KYMW1312Component.setEnabledBtn();
  }
}
